import slick from 'slick-carousel';
import objectFit from 'object-fit';
import uploadPreview from './jquery.uploadPreview';
import $ from 'jquery';

export default function () {
  
  $('.js-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    appendDots: '.js-slider-dots',
    prevArrow: '.js-slider-prev',
    nextArrow: '.js-slider-next'
  });
  
  $('.js-slider-review').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    adaptiveHeight: true,
    prevArrow: '<button class="slider-prev" type="button"><i class="fa fa-angle-double-left"></i></button>',
    nextArrow: '<button class="slider-next js-slider-next" type="button"><i class="fa fa-angle-double-right"></i></button>'
  });
  
  objectFit.polyfill({
    selector: '[data-cover]',
    fittype: 'cover',
    disableCrossDomain: 'true'
  });
  
  $('.js-file').each(function () {
    $.uploadPreview({
      input_field: $(this).find('.js-image-upload'),
      // preview_box: ".image-preview",
      label_field: $(this).find('.js-image-label'),
      label_default: "Choose File",
      label_selected: "Change File",
      no_label: false,
      success_callback: function () {
      }
    });
  });
  
  $.uploadPreview({
    input_field: '#image-upload',
    // preview_box: ".image-preview",
    label_field: '#image-label',
    label_default: "Choose File",
    label_selected: "Change File",
    no_label: false,
    success_callback: function () {
    }
  });
  
}


// WEBPACK FOOTER //
// ./core/init.plugins.js